(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-about-faq]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('.bw-about__faq-q');
        if (!btn) return;
        btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-announce"] && !Shopify.designMode) return;
  try {
    
  /* Transform the promo bar to its compact "Buy Now" state after ~75% of the hero is scrolled. */
  (function () {
    var bar = document.querySelector('[data-annc]');
    if (!bar) return;
    if (bar.classList.contains('is-pdp')) return;   /* PDPs don't transform — the ATC bar is sticky there */
    function trigger() {
      var hero = document.querySelector('.bw-hero') || document.querySelector('main .shopify-section');
      if (hero) {
        var top = hero.getBoundingClientRect().top + (window.pageYOffset || 0);
        return top + hero.offsetHeight * 0.75;
      }
      return 380;
    }
    var point = trigger();
    var ticking = false;
    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y >= point) bar.classList.add('is-scrolled');
      else bar.classList.remove('is-scrolled');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', function () { point = trigger(); }, { passive: true });
    update();
  })();

  (function () {
    document.querySelectorAll('[data-annc-timer]').forEach(function (t) {
      var end = new Date(t.getAttribute('data-end')).getTime();
      if (isNaN(end)) return;
      var dEl = t.querySelector('[data-d]'), hEl = t.querySelector('[data-h]'),
          mEl = t.querySelector('[data-m]'), sEl = t.querySelector('[data-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = end - Date.now();
        if (diff < 0) diff = 0;
        var d = Math.floor(diff / 86400000),
            h = Math.floor((diff % 86400000) / 3600000),
            m = Math.floor((diff % 3600000) / 60000),
            s = Math.floor((diff % 60000) / 1000);
        if (dEl) dEl.textContent = pad(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
        if (diff === 0 && window.__anncStop) clearInterval(window.__anncStop);
      }
      tick();
      window.__anncStop = setInterval(tick, 1000);
    });
  })();

  (function () {
    document.querySelectorAll('[data-loc-root]').forEach(function (root) {
      var toggle = root.querySelector('[data-loc-toggle]'),
          panel  = root.querySelector('[data-loc-panel]'),
          search = root.querySelector('[data-loc-search]'),
          list   = root.querySelector('[data-loc-list]'),
          input  = root.querySelector('[data-loc-input]'),
          empty  = root.querySelector('[data-loc-empty]');
      if (!toggle || !panel || !list) return;
      var opts = Array.prototype.slice.call(list.querySelectorAll('.bw-loc__opt'));
      var hi = -1;

      function clearHi() { opts.forEach(function (o) { o.classList.remove('is-hi'); }); hi = -1; }
      function visible() { return opts.filter(function (o) { return o.parentNode.style.display !== 'none'; }); }
      function setHi(i) { var v = visible(); clearHi(); if (!v.length) return; hi = (i + v.length) % v.length; v[hi].classList.add('is-hi'); v[hi].scrollIntoView({ block: 'nearest' }); }
      function filter(q) {
        q = (q || '').trim().toLowerCase();
        var shown = 0;
        opts.forEach(function (o) {
          var m = !q || o.getAttribute('data-name').indexOf(q) !== -1;
          o.parentNode.style.display = m ? '' : 'none';
          if (m) shown++;
        });
        if (empty) empty.hidden = shown > 0;
        clearHi();
      }
      function choose(o) { if (!o) return; input.value = o.getAttribute('data-code'); root.submit(); }
      function outside(e) { if (!root.contains(e.target)) close(); }
      function onKey(e) {
        if (e.key === 'Escape') { close(); toggle.focus(); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); setHi(hi + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setHi(hi - 1); }
        else if (e.key === 'Enter') { e.preventDefault(); var v = visible(); if (v.length) choose(hi >= 0 ? v[hi] : v[0]); }
      }
      function open() {
        panel.hidden = false; root.setAttribute('data-open', ''); toggle.setAttribute('aria-expanded', 'true');
        search.value = ''; filter('');
        var sel = list.querySelector('.bw-loc__opt.is-sel'); if (sel) sel.scrollIntoView({ block: 'nearest' });
        setTimeout(function () { search.focus(); }, 20);
        document.addEventListener('click', outside, true);
        document.addEventListener('keydown', onKey, true);
      }
      function close() {
        panel.hidden = true; root.removeAttribute('data-open'); toggle.setAttribute('aria-expanded', 'false'); clearHi();
        document.removeEventListener('click', outside, true);
        document.removeEventListener('keydown', onKey, true);
      }
      toggle.addEventListener('click', function () { panel.hidden ? open() : close(); });
      search.addEventListener('input', function () { filter(search.value); });
      opts.forEach(function (o) { o.addEventListener('click', function () { choose(o); }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prose = document.querySelector('[data-art-prose]');
    if (!prose) return;
    var VIEW_CIT = prose.getAttribute('data-i18n-view-cit') || 'View Citations';
    var CLOSE_CIT = prose.getAttribute('data-i18n-close-cit') || 'Close Citations';

    /* ---- Reading progress bar ---- */
    var bar = document.querySelector('[data-art-progress]');
    if (bar) {
      var onScroll = function () {
        var doc = document.documentElement;
        var total = doc.scrollHeight - doc.clientHeight;
        var pct = total > 0 ? (doc.scrollTop / total) * 100 : 0;
        bar.style.width = pct + '%';
      };
      document.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---- Collapsible citations ---- */
    var headings = prose.querySelectorAll('h2, h3, h4');
    var refHead = null;
    headings.forEach(function (h) {
      if (!refHead && /^(references|citations)\b/i.test(h.textContent.trim())) refHead = h;
    });
    if (refHead) {
      var panel = document.createElement('div');
      panel.className = 'bw-art__cits';
      panel.id = 'bw-citations';
      panel.hidden = true;
      var node = refHead.nextElementSibling;
      var moved = [refHead];
      while (node && (node.tagName === 'OL' || node.tagName === 'UL')) {
        moved.push(node);
        node = node.nextElementSibling;
      }
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'bw-art__cit-toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', 'bw-citations');
      toggle.innerHTML = '<span class="bw-art__cit-icon" aria-hidden="true">+</span><span data-cit-label>' + VIEW_CIT + '</span>';
      refHead.parentNode.insertBefore(toggle, refHead);
      moved.forEach(function (n) { panel.appendChild(n); });
      toggle.parentNode.insertBefore(panel, toggle.nextSibling);

      function setOpen(open) {
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.querySelector('.bw-art__cit-icon').textContent = open ? '−' : '+';
        toggle.querySelector('[data-cit-label]').textContent = open ? CLOSE_CIT : VIEW_CIT;
      }
      toggle.addEventListener('click', function () { setOpen(panel.hidden); });

      /* meta "N Citations" link */
      var lis = panel.querySelectorAll('li').length;
      var citLink = document.querySelector('[data-cit-link]');
      var citDot = document.querySelector('[data-cit-dot]');
      if (lis > 0 && citLink) {
        citLink.querySelector('[data-cit-count]').textContent = lis;
        citLink.hidden = false;
        if (citDot) citDot.hidden = false;
        citLink.addEventListener('click', function (e) {
          e.preventDefault();
          setOpen(true);
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      /* inline footnote sup links should open the panel first */
      prose.addEventListener('click', function (e) {
        var a = e.target.closest('sup a, a[href^="#"]');
        if (!a) return;
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = null;
        try { target = document.getElementById(decodeURIComponent(href.slice(1))); } catch (err) {}
        if (target && panel.contains(target)) {
          e.preventDefault();
          setOpen(true);
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    /* ---- Share drawer ---- */
    var wrap = document.querySelector('[data-share-wrap]');
    var openBtn = document.querySelector('[data-share-open]');
    if (wrap && openBtn) {
      function shareOpen() { wrap.hidden = false; document.documentElement.style.overflow = 'hidden'; }
      function shareClose() { wrap.hidden = true; document.documentElement.style.overflow = ''; }
      openBtn.addEventListener('click', function () {
        if (navigator.share && window.matchMedia('(max-width: 700px)').matches) {
          navigator.share({ title: document.title, url: location.href }).catch(function () { shareOpen(); });
        } else { shareOpen(); }
      });
      wrap.querySelectorAll('[data-share-close]').forEach(function (el) { el.addEventListener('click', shareClose); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shareClose(); });
      var copyBtn = wrap.querySelector('[data-share-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var url = copyBtn.getAttribute('data-url') || location.href;
          var done = function () { copyBtn.querySelector('[data-share-copy-label]').textContent = 'Link copied ✓'; };
          if (navigator.clipboard) navigator.clipboard.writeText(url).then(done);
          else { var t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t); done(); }
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ben-tabs]').forEach(function (tabs) {
      var section = tabs.closest('section');
      var panels = section.querySelector('[data-ben-panels]');
      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('.bw-ben__tab');
        if (!btn) return;
        var i = btn.getAttribute('data-tab');
        tabs.querySelectorAll('.bw-ben__tab').forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        panels.querySelectorAll('.bw-ben__panel').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === i); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-bw-cart]');
    if (!root) return;
    var body = root.querySelector('[data-cd-body]');
    var foot = root.querySelector('[data-cd-foot]');
    var giftEl = root.querySelector('[data-cd-gift]');
    var upsellEl = root.querySelector('[data-cd-upsell]');
    var subtotalEl = root.querySelector('[data-cd-subtotal]');
    var shipFill = root.querySelector('[data-cd-ship-fill]');
    var shipMsg = root.querySelector('[data-cd-ship-msg]');
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var continueUrl = root.getAttribute('data-continue-url') || '/';

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-cd-config]').textContent); } catch (e) { cfg = {}; }
    var I18N = {}; try { I18N = JSON.parse(root.querySelector('[data-cd-i18n]').textContent); } catch (e) {}

    function money(cents) {
      cents = parseInt(cents, 10) || 0;
      function fmt(number, precision, thousands, decimal) {
        thousands = thousands == null ? ',' : thousands;
        decimal = decimal == null ? '.' : decimal;
        var n = (number / 100).toFixed(precision);
        var parts = n.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return dollars + (parts[1] ? decimal + parts[1] : '');
      }
      var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      var val;
      if (key === 'amount_no_decimals') val = fmt(cents, 0);
      else if (key === 'amount_with_comma_separator') val = fmt(cents, 2, '.', ',');
      else if (key === 'amount_no_decimals_with_comma_separator') val = fmt(cents, 0, '.', ',');
      else if (key === 'amount_with_space_separator') val = fmt(cents, 2, ' ', ',');
      else if (key === 'amount_no_decimals_with_space_separator') val = fmt(cents, 0, ' ', ',');
      else val = fmt(cents, 2);
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, val);
    }

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    var lastSavings = 0;
    function renderItems(cart) {
      var html = '';
      lastSavings = 0;
      cart.items.forEach(function (it, i) {
        var line = i + 1;
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';

        // "Was" price + discount %. Subscription lines use the selling-plan compare price
        // (the 20%/10% saving); one-time lines use the variant MSRP; anything else falls
        // back to a line-level discount (e.g. the Buy-X-Get-Y cross-sell discount).
        var qty = it.quantity || 1;
        var paidLine = it.final_line_price;
        var wasLine = 0;
        var sp = it.selling_plan_allocation;
        var ratio = discountRatio[it.variant_id];
        if (sp && sp.compare_at_price && sp.compare_at_price * qty > paidLine) wasLine = sp.compare_at_price * qty;
        else if (ratio && ratio > 1.001) wasLine = Math.round(paidLine * ratio);   // full price (variant MSRP) struck — currency-safe
        else if (it.original_line_price && it.original_line_price > paidLine) wasLine = it.original_line_price;
        var pct = wasLine ? Math.round((wasLine - paidLine) / wasLine * 100) : 0;
        if (wasLine > paidLine) lastSavings += (wasLine - paidLine);
        var upgOwn = {}; (cfg.xsell || []).forEach(function (c) { if (c.own) upgOwn[c.own] = true; });
        var upgradeable = !sp && (cfg.nudge || {}).plan90 && upgOwn[it.handle];

        var priceBlock =
          (pct > 0 ? '<span class="bw-cd__item-off">' + (I18N.off || '[pct]% off').replace('[pct]', pct) + '</span>' : '') +
          '<span class="bw-cd__item-pricewrap">' +
            (wasLine ? '<s class="bw-cd__item-was">' + money(wasLine) + '</s>' : '') +
            '<span class="bw-cd__item-price">' + money(paidLine) + '</span>' +
          '</span>';

        html +=
          '<div class="bw-cd__item" data-line="' + line + '">' +
            (img ? '<img class="bw-cd__item-img" src="' + img + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '<span class="bw-cd__item-img"></span>') +
            '<div class="bw-cd__item-mid">' +
              '<div class="bw-cd__item-title">' + esc(it.product_title) + '</div>' +
              (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="bw-cd__item-variant">' + esc(it.variant_title) + '</div>' : '') +
              '<div class="bw-cd__qty">' +
                '<button type="button" data-cd-dec aria-label="Decrease">&minus;</button>' +
                '<span>' + qty + '</span>' +
                '<button type="button" data-cd-inc aria-label="Increase">&plus;</button>' +
              '</div>' +
            '</div>' +
            '<div class="bw-cd__item-right">' +
              priceBlock +
              (upgradeable ? '<button type="button" class="bw-cd__upg" data-cd-swap data-key="' + esc(it.key) + '" data-handle="' + esc(it.handle) + '">' + esc(I18N.upgrade || 'Upgrade · save 20%') + '</button>' : '') +
              '<button type="button" class="bw-cd__remove" data-cd-remove>' + (I18N.remove || 'Remove') + '</button>' +
            '</div>' +
          '</div>';
      });
      body.innerHTML = html;
    }

    function renderUpsell(cart) {
      upsellEl.innerHTML = '';
      upsellEl.hidden = true;
      if (!cart.items || !cart.items.length) return;

      var handles = {};
      cart.items.forEach(function (it) { if (it.handle) handles[it.handle] = true; });

      // No upsell when the bundle is already in the cart — it's the top offer, nothing to add.
      if (cfg.bundleHandle && handles[cfg.bundleHandle]) { upsellEl.hidden = true; upsellEl.innerHTML = ''; return; }

      var html = '';

      // Priority 1: nudge a 30-day subscriber up to the 90-day plan.
      // Preview mode forces the card to render (against the first line) so it can be
      // seen before native subscription plan IDs are wired; the button is inert then.
      var n = cfg.nudge || {};
      var target = null, preview = false;
      if (n.enabled && n.plan30 && n.plan90) {
        cart.items.forEach(function (it) {
          if (target) return;
          var sp = it.selling_plan_allocation;
          if (sp && sp.selling_plan && String(sp.selling_plan.id) === String(n.plan30)) target = it;
        });
      }
      var otNudge = false;
      if (!target && n.enabled && n.plan90) {
        var anySub = false; cart.items.forEach(function (it) { if (it.selling_plan_allocation) anySub = true; });
        var ownHandles = {}; (cfg.xsell || []).forEach(function (c) { if (c.own) ownHandles[c.own] = true; });
        if (!anySub) cart.items.forEach(function (it) { if (ownHandles[it.handle]) otNudge = true; });  /* no card: inline Upgrade pill + bar sentence instead */
      }
      if (!target && n.enabled && n.preview) { target = cart.items[0]; preview = true; }
      if (target) {
        html +=
          '<div class="bw-cd__nudge">' +
            '<span class="bw-cd__nudge-eyebrow">' + (I18N.better_value || 'Better value') + (preview ? ' · preview' : '') + '</span>' +
            '<div class="bw-cd__nudge-title">' + esc(otNudge ? (I18N.nudge_ot_title || n.title) : n.title) + '</div>' +
            '<p class="bw-cd__nudge-text">' + esc(otNudge ? (I18N.nudge_ot_text || n.text) : n.text) + '</p>' +
            '<button type="button" class="bw-cd__nudge-cta" data-cd-swap' + (preview ? ' data-preview="1"' : '') + ' ' +
              'data-key="' + esc(target.key) + '" data-handle="' + esc(target.handle) + '">' + esc(otNudge ? (I18N.nudge_ot_cta || n.cta) : n.cta) + '</button>' +
          '</div>';
      }

      // Priority 2: cross-sell.
      //   Subscription cart -> add the complementary bottle at the plan's matching % (per-item discount).
      //   One-time cart     -> offer BOTH products; adding a 2nd item unlocks 10% off the order + free shipping.
      if (cfg.xsellEnabled && cfg.xsell && cfg.xsell.length && (!target || preview || otNudge)) {
        var xsRow = function (r) {
          return '<div class="bw-cd__xs-row">' +
            '<span class="bw-cd__xs-thumb">' +
              (r.img ? '<img class="bw-cd__xs-img" src="' + esc(r.img) + '" alt="" loading="lazy">' : '<span class="bw-cd__xs-img"></span>') +
              (r.pct ? '<span class="bw-cd__xs-badge">' + (I18N.off || '[pct]% off').replace('[pct]', r.pct) + '</span>' : '') +
            '</span>' +
            '<div>' +
              '<div class="bw-cd__xs-name">' + esc(r.name) + '</div>' +
              '<div class="bw-cd__xs-meta">' +
                (r.was ? '<s class="bw-cd__xs-was">' + money(r.was) + '</s>' : '') +
                '<span class="bw-cd__xs-price">' + money(r.price) + '</span>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="bw-cd__xs-add" data-cd-xadd data-variant="' + r.id + '"' + (r.plan ? ' data-plan="' + r.plan + '"' : '') + '>' + (I18N.add || 'Add') + '</button>' +
          '</div>';
        };
        var subPlan = null;
        cart.items.forEach(function (it) { var s = it.selling_plan_allocation; if (s && s.selling_plan) subPlan = String(s.selling_plan.id); });
        var xsBlurb = '', xsRows = '';
        if (subPlan) {
          // subscription cart: add the complementary bottle on the same plan (10% monthly / 20% quarterly)
          var pick = null;
          for (var i = 0; i < cfg.xsell.length; i++) { var c = cfg.xsell[i]; if (!handles[c.own] && handles[c.trigger]) { pick = c; break; } }
          if (pick) {
            var isQ = n.plan90 && subPlan === String(n.plan90);
            var pct = isQ ? 20 : 10;
            xsBlurb = esc(pick.blurb.replace('[pct]', pct));
            xsRows = xsRow({ name: pick.name, img: pick.img, was: pick.v30price, price: Math.round(pick.v30price * (100 - pct) / 100), pct: pct, id: pick.v30id, plan: isQ ? n.plan90 : n.plan30 });
          }
        } else if ((cart.item_count || 0) < 2) {
          // one-time cart, under 2 items: offer BOTH products — adding a 2nd unlocks the order deal
          xsBlurb = (I18N.xs_unlock || 'Add one more — unlock <strong>10% off your order + free shipping</strong>.');
          // adding a 2nd item triggers the order-level 10% Buy-X-Get-Y discount, so preview each row at that price
          var otPct = cfg.xsOrderPct || 10;
          xsRows = cfg.xsell.map(function (c) { return xsRow({ name: c.name, img: c.img, was: c.v30price, price: Math.round(c.v30price * (100 - otPct) / 100), pct: otPct, id: c.v30id, plan: '' }); }).join('');
        }
        if (xsRows) {
          html += '<div class="bw-cd__xs">' +
              '<p class="bw-cd__xs-head">' + esc(cfg.xsellTitle || 'Complete your ritual') + '</p>' +
              (xsBlurb ? '<p class="bw-cd__xs-blurb">' + xsBlurb + '</p>' : '') +
              xsRows +
            '</div>';
        }
      }

      if (html) { upsellEl.innerHTML = html; upsellEl.hidden = false; }
    }

    // Count a cart's "pack units": 1-Pack = 1, 2-Pack = 2, 3-Pack = 3 (× quantity).
    // The bundle and any subscription qualify outright. Free shipping at 3 units.
    function packUnits(cart) {
      var freeUnits = cfg.freeUnits || 2;
      var units = 0, hasSub = false;
      cart.items.forEach(function (it) {
        if (it.selling_plan_allocation) hasSub = true;
        var u = 1;
        var t = it.variant_title || it.title || '';
        if (/3\s*pack/i.test(t)) u = 3;
        else if (/2\s*pack/i.test(t)) u = 2;
        if (cfg.bundleHandle && it.handle === cfg.bundleHandle) u = Math.max(u, freeUnits);
        units += u * (it.quantity || 1);
      });
      return { units: units, hasSub: hasSub, freeUnits: freeUnits };
    }

    function render(cart) {
      if (shipFill) {
        var pk = packUnits(cart);
        var qualifies = pk.hasSub || pk.units >= pk.freeUnits;
        shipFill.style.width = (pk.hasSub ? 100 : Math.min(50, pk.units / pk.freeUnits * 50)) + '%';
        var ms1 = root.querySelector('[data-cd-ms1]'), ms2 = root.querySelector('[data-cd-ms2]');
        if (ms1) ms1.classList.toggle('is-hit', qualifies); var l1 = root.querySelector('[data-cd-ms1-label]'), l2 = root.querySelector('[data-cd-ms2-label]'); if (l1) l1.classList.toggle('is-hit', qualifies); if (l2) l2.classList.toggle('is-hit', pk.hasSub);
        if (ms2) { ms2.classList.toggle('is-hit', pk.hasSub); var sw = null; if (!pk.hasSub) cart.items.forEach(function (it) { if (!sw && !it.selling_plan_allocation) sw = it; }); if (sw) { ms2.setAttribute('data-key', sw.key); ms2.setAttribute('data-handle', sw.handle); } else { ms2.removeAttribute('data-key'); } }
        if (pk.hasSub) {
          shipMsg.innerHTML = I18N.ship_sub || 'Free shipping — <strong>included with your subscription</strong>';
        } else if (pk.units >= pk.freeUnits) {
          var swapLine = null; cart.items.forEach(function (it) { if (!swapLine && !it.selling_plan_allocation && (cfg.xsell || []).some(function (c) { return c.own === it.handle; })) swapLine = it; });
          shipMsg.innerHTML = swapLine ? ((I18N.ship_upgrade || 'Free shipping unlocked. <button type="button" data-cd-ms2-swap data-key="[key]" data-handle="[handle]">Switch to the 90-Day plan and save 20%</button>').replace('[key]', swapLine.key).replace('[handle]', swapLine.handle))
                                       : (I18N.ship_unlocked || "You've unlocked <strong>free shipping!</strong>");
        } else {
          var need = pk.freeUnits - pk.units;
          var unit = need === 1 ? (I18N.pack_one || 'pack') : (I18N.pack_other || 'packs');
          shipMsg.innerHTML = (I18N.ship_deal || 'Add <strong>[count] more [unit]</strong> to unlock <strong>10% off + free shipping</strong>.')
            .replace('[count]', need).replace('[unit]', unit);
        }
      }
      if (!cart.items || cart.items.length === 0) {
        foot.hidden = true;
        if (giftEl) giftEl.hidden = true;
        upsellEl.hidden = true;
        upsellEl.innerHTML = '';
        body.innerHTML =
          '<div class="bw-cd__empty"><h3>' + (I18N.empty_title || 'Your cart is empty') + '</h3>' +
          '<p>' + (I18N.empty_body || 'Add your favourite Blushwood Berry to your cart.') + '</p>' +
          '<a class="bw-cd__shopnow" href="' + continueUrl + '">' + (I18N.shop_now || 'Shop now') + '</a></div>';
        return;
      }
      renderItems(cart);
      renderUpsell(cart);
      foot.hidden = false;
      var saveEl = root.querySelector('[data-cd-save]'), saveAmt = root.querySelector('[data-cd-save-amt]');
      if (saveEl) { if (lastSavings > 0) { saveAmt.textContent = money(lastSavings); saveEl.hidden = false; } else { saveEl.hidden = true; } }
      if (giftEl) giftEl.hidden = false;
      if (cart.total_discount && cart.total_discount > 0) {
        subtotalEl.innerHTML = '<s style="color:var(--color-sage-text);font-weight:400;margin-right:8px;">' + money(cart.original_total_price) + '</s>' + money(cart.total_price);
      } else {
        subtotalEl.textContent = money(cart.total_price);
      }
    }

    function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

    // /cart.js doesn't expose compare-at prices, so pull each line's variant compare/price RATIO
    // from the product JSON. The ratio is currency-independent, so applying it to the cart's paid
    // price yields the full "was" figure in whatever currency the cart is presented in.
    var discountRatio = {};   // variant_id -> compare_at_price / price  (>1 when discounted)
    var ratioLoaded = {};
    function loadRatios(cart) {
      var handles = {};
      (cart.items || []).forEach(function (it) { if (it.handle && !ratioLoaded[it.handle]) handles[it.handle] = true; });
      var list = Object.keys(handles);
      if (!list.length) return Promise.resolve();
      return Promise.all(list.map(function (h) {
        return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (p) {
            ratioLoaded[h] = true;
            (p.variants || []).forEach(function (v) {
              if (v.compare_at_price && v.price && v.compare_at_price > v.price) discountRatio[v.id] = v.compare_at_price / v.price;
            });
          })
          .catch(function () {});
      }));
    }

    function refresh() { return fetchCart().then(function (cart) { return loadRatios(cart).then(function () { render(cart); }); }); }
    function open() { root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; refresh(); }
    function close() { root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

    function change(line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(render).then(syncCount);
    }

    function addVariant(id, sellingPlan) {
      var item = { id: id, quantity: 1 };
      if (sellingPlan) item.selling_plan = parseInt(sellingPlan, 10);
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) { return r.json(); });
    }

    // Swap a 30-day line to the same product's 90-day plan.
    function swapTo90(key, handle) {
      var n = cfg.nudge || {};
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (prod) {
          var v90 = null;
          (prod.variants || []).forEach(function (v) {
            var t = (v.public_title || v.title || v.name || '');
            if (!v90 && t.indexOf(n.key90 || '3 Pack') >= 0) v90 = v;
          });
          if (!v90) return;
          return addVariant(v90.id, n.plan90).then(function () {
            return fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            }).then(function (r) { return r.json(); });
          });
        })
        .then(function () { refresh(); syncCount(); });
    }

    function syncCount() {
      fetchCart().then(function (c) {
        document.querySelectorAll('.bw-cartcount').forEach(function (el) { el.textContent = c.item_count; });
      });
    }

    // Open when a /cart link (cart icon) is clicked
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (link) {
        var url = new URL(link.href, window.location.origin);
        // Match /cart AND localized paths like /de/cart, /en-gb/cart (optional locale prefix).
        if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/cart$/i.test(url.pathname.replace(/\/$/, '')) && !e.metaKey && !e.ctrlKey) {
          e.preventDefault(); open(); return;
        }
      }
      if (e.target.closest('[data-cd-close]') || e.target.classList.contains('bw-cd__overlay')) { close(); return; }

      var xadd = e.target.closest('[data-cd-xadd]');
      if (xadd) { addVariant(xadd.getAttribute('data-variant'), xadd.getAttribute('data-plan')).then(function () { refresh(); syncCount(); }); return; }

      var ms2c = e.target.closest('[data-cd-ms2-swap]'); if (!ms2c && e.target.closest('[data-cd-ms2-label]')) ms2c = root.querySelector('[data-cd-ms2]');
      if (ms2c) { var k2 = ms2c.getAttribute('data-key') || (root.querySelector('[data-cd-ms2]') || {}).getAttribute && root.querySelector('[data-cd-ms2]').getAttribute('data-key'); var h2 = ms2c.getAttribute('data-handle') || root.querySelector('[data-cd-ms2]').getAttribute('data-handle'); if (k2 && !ms2c.classList.contains('is-hit')) swapTo90(k2, h2); return; }
      var swap = e.target.closest('[data-cd-swap]');
      if (swap) { if (!swap.getAttribute('data-preview')) swapTo90(swap.getAttribute('data-key'), swap.getAttribute('data-handle')); return; }

      var item = e.target.closest('.bw-cd__item');
      if (item) {
        var line = parseInt(item.getAttribute('data-line'), 10);
        var qtyEl = item.querySelector('.bw-cd__qty span');
        var q = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
        if (e.target.closest('[data-cd-inc]')) { change(line, q + 1); }
        else if (e.target.closest('[data-cd-dec]')) { change(line, Math.max(0, q - 1)); }
        else if (e.target.closest('[data-cd-remove]')) { change(line, 0); }
      }
    });

    // Intercept add-to-cart forms anywhere → add then open drawer
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function () { open(); syncCount(); })
        .catch(function () { form.submit(); });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-cart-page"]) return;
  try {
    
  (function () {
    function root() { return document.querySelector('[data-bwc]'); }
    if (!root()) return;

    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); });
    }
    function rerender() {
      var el = root(); if (!el) return Promise.resolve();
      var id = el.getAttribute('data-section');
      return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-bwc]');
          if (fresh) { el.replaceWith(fresh); }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (cart) document.querySelectorAll('.bw-cartcount').forEach(function (c) { c.textContent = cart.item_count; });
          watchSticky();
        });
    }
    function busy(p) { var el = root(); if (el) el.classList.add('is-loading'); return p.then(rerender).catch(function () { window.location.reload(); }); }

    document.addEventListener('click', function (e) {
      var el = root(); if (!el || !el.contains(e.target)) return;
      var item = e.target.closest('.bwc__item');
      if (item) {
        var line = parseInt(item.getAttribute('data-line'), 10);
        var q = parseInt((item.querySelector('.bwc__qty span') || {}).textContent || '1', 10);
        if (e.target.closest('[data-bwc-inc]')) { busy(post('/cart/change.js', { line: line, quantity: q + 1 })); return; }
        if (e.target.closest('[data-bwc-dec]')) { busy(post('/cart/change.js', { line: line, quantity: Math.max(0, q - 1) })); return; }
        if (e.target.closest('[data-bwc-remove]')) { busy(post('/cart/change.js', { line: line, quantity: 0 })); return; }
      }
      var add = e.target.closest('[data-bwc-add]');
      if (add) {
        var it = { id: parseInt(add.getAttribute('data-variant'), 10), quantity: 1 };
        if (add.getAttribute('data-plan')) it.selling_plan = parseInt(add.getAttribute('data-plan'), 10);
        busy(post('/cart/add.js', { items: [it] })); return;
      }
      var swap = e.target.closest('[data-bwc-swap]');
      if (swap) {
        var plan90 = el.getAttribute('data-plan90');
        busy(fetch('/products/' + swap.getAttribute('data-handle') + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var v90 = (p.variants || []).filter(function (v) { return /3\s*pack/i.test(v.public_title || v.title || ''); })[0];
            if (!v90) return;
            return post('/cart/add.js', { items: [{ id: v90.id, quantity: 1, selling_plan: parseInt(plan90, 10) }] })
              .then(function () { return post('/cart/change.js', { id: swap.getAttribute('data-key'), quantity: 0 }); });
          }));
        return;
      }
      if (e.target.closest('[data-bwc-go]')) { var b = el.querySelector('[data-bwc-checkout]'); if (b) b.click(); }
    });

    // Mobile sticky checkout bar: hide it while the summary's own checkout button is on screen.
    var io = null;
    function watchSticky() {
      var el = root(); if (!el) return;
      var bar = el.querySelector('[data-bwc-sticky]'); var btn = el.querySelector('[data-bwc-checkout]');
      if (!bar || !btn || !('IntersectionObserver' in window)) return;
      if (io) io.disconnect();
      io = new IntersectionObserver(function (en) { bar.classList.toggle('is-hidden', en[0].isIntersecting); }, { threshold: 0.2 });
      io.observe(btn);
    }
    watchSticky();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ai-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // best-effort: open a known chat/AI widget launcher if present
        var sels = ['[class*="launcher" i]','[id*="chat-widget" i]','[class*="chat-button" i]','[aria-label*="chat" i]','button[class*="widget" i]'];
        for (var i = 0; i < sels.length; i++) {
          var el = document.querySelector(sels[i]);
          if (el && el.offsetParent !== null) { el.click(); return; }
        }
        // fallback: focus the message field
        var m = document.querySelector('[name="contact[body]"]');
        if (m) { m.focus(); m.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-cookie-consent"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-bw-cc]');
    if (!root) return;
    var accept = root.querySelector('[data-bw-cc-accept]');
    var decline = root.querySelector('[data-bw-cc-decline]');

    function show() { root.hidden = false; }
    function hide() { root.hidden = true; }

    function apply(granted, api) {
      // Grant/deny every consent category, then hide the banner.
      api.setTrackingConsent({
        analytics: granted,
        marketing: granted,
        preferences: granted,
        sale_of_data: granted
      }, hide);
    }

    // Hide Shopify's built-in consent banner/modal so only our custom one shows. Called ONLY after
    // our API init succeeds — if init ever fails, the native banner is left intact as a fallback.
    function hideNative() {
      document.querySelectorAll('#shopify-pc__banner, #shopify-pc__modal').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    }

    function init(api) {
      if (!api) return;
      hideNative();
      // The native banner injects asynchronously — keep hiding it as it appears (then stop).
      var mo = new MutationObserver(hideNative);
      try { mo.observe(document.body, { childList: true }); } catch (e) {}
      setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 8000);

      // Only show when Shopify says consent is required in this region and no decision exists yet.
      var need = false;
      try { need = api.shouldShowGDPRBanner(); } catch (e) { need = false; }
      if (need) show();
      accept.addEventListener('click', function () { apply(true, api); });
      decline.addEventListener('click', function () { apply(false, api); });
    }

    if (window.Shopify && window.Shopify.customerPrivacy) {
      init(window.Shopify.customerPrivacy);
    } else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) init(window.Shopify && window.Shopify.customerPrivacy);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-faq-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // accordion (independent toggles)
    document.querySelectorAll('[data-faq-acc]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var b = e.target.closest('.bw-faqp__q');
        if (!b) return;
        b.setAttribute('aria-expanded', b.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
    });
    // smooth scroll on nav click
    document.querySelectorAll('[data-faq-nav] a[href^="#faqcat-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById(this.getAttribute('href').slice(1));
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', this.getAttribute('href')); }
      });
    });
    // scrollspy
    var groups = document.querySelectorAll('[data-faqgroup]');
    var links = document.querySelectorAll('[data-faqnav]');
    if ('IntersectionObserver' in window && groups.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var id = en.target.getAttribute('data-faqgroup');
            links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-faqnav') === id); });
          }
        });
      }, { rootMargin: '-96px 0px -60% 0px', threshold: 0 });
      groups.forEach(function (g) { io.observe(g); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-faq]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('.bw-faq__q');
        if (!btn) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        list.querySelectorAll('.bw-faq__q').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Hero benefit chips are deep-links: scroll to the benefits section and pre-select
    // the matching tab (kills dead clicks; rewards curiosity).
    var chips = document.querySelectorAll('.bw-hero__chip');
    if (!chips.length) return;
    function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
    function activate(chip) {
      var tabsWrap = document.querySelector('[data-ben-tabs]');
      if (!tabsWrap) return;
      var want = norm(chip.textContent);
      var tabs = Array.prototype.slice.call(tabsWrap.querySelectorAll('.bw-ben__tab'));
      var match = null;
      tabs.forEach(function (t) {
        var lbl = norm(t.textContent);
        if (lbl === want || lbl.indexOf(want) !== -1 || want.indexOf(lbl) !== -1) match = t;
      });
      if (!match) { // fall back to first significant word (e.g. "Immune", "Inflammatory")
        var w = want.split(' ')[0];
        tabs.forEach(function (t) { if (!match && norm(t.textContent).indexOf(w) !== -1) match = t; });
      }
      if (match) match.click();
      // Scroll the page to the benefits section (offset for the sticky header).
      var sec = tabsWrap.closest('section');
      if (sec) {
        var y = sec.getBoundingClientRect().top + window.pageYOffset - 64;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
      // Center the selected tab within its horizontal scroller so you can see it's active.
      if (match) {
        try {
          var wr = tabsWrap.getBoundingClientRect(), tr = match.getBoundingClientRect();
          var delta = (tr.left - wr.left) - (wr.width - tr.width) / 2;
          tabsWrap.scrollBy({ left: delta, behavior: 'smooth' });
        } catch (e) {}
      }
    }
    chips.forEach(function (chip) {
      chip.setAttribute('role', 'button');
      chip.setAttribute('tabindex', '0');
      chip.addEventListener('click', function () { activate(chip); });
      chip.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(chip); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ing-faq]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('.bw-ing__faq-q');
        if (!btn) return;
        btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-ninety"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bw-90__cta').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#' && href.length > 1) {
        a.addEventListener('click', function (e) {
          var t = document.querySelector(href);
          if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bw-pdp').forEach(function (root) {
      var main = root.querySelector('[data-pdp-main]');
      var slidesWrap = root.querySelector('[data-pdp-slides]');
      var stageImgs = root.querySelectorAll('[data-pdp-slide] img');
      var curIndex = 0;

      // Interactive image overlays (pioneers callout + certs) — don't let clicks open the zoom.
      var pio = root.querySelector('[data-pdp-pio]');
      var certsEl = root.querySelector('.bw-pdp__certs');
      var pioDismissed = false;

      // The pioneers callout + cert badge belong only on the first/hero image —
      // hide them on every other image so they never cover on-image text.
      function updateOverlays(idx) {
        if (pio) pio.classList.toggle('is-hidden', idx !== 0 || pioDismissed);
        if (certsEl) certsEl.classList.toggle('is-hidden', idx !== 0);
      }

      if (pio) {
        pio.addEventListener('click', function (e) { e.stopPropagation(); });
        // Always show on page load; dismissing only hides for the current view (not persisted).
        var pioX = pio.querySelector('[data-pdp-pio-close]');
        if (pioX) pioX.addEventListener('click', function (e) { e.stopPropagation(); pioDismissed = true; pio.classList.add('is-hidden'); });
      }
      if (certsEl) certsEl.addEventListener('click', function (e) { e.stopPropagation(); });

      function setActiveThumb(i) {
        root.querySelectorAll('.bw-pdp__thumb').forEach(function (x) {
          x.classList.toggle('is-active', parseInt(x.getAttribute('data-index') || '-1', 10) === i);
        });
      }
      function goToStage(i, smooth) {
        var n = stageImgs.length; if (n === 0) return;
        if (i < 0) i = 0; if (i > n - 1) i = n - 1;
        curIndex = i;
        if (slidesWrap && slidesWrap.children[i]) {
          slidesWrap.scrollTo({ left: slidesWrap.children[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        }
        setActiveThumb(i); updateOverlays(i);
      }
      // Thumbnail click still works — it jumps the swipeable carousel to that photo
      root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          goToStage(parseInt(t.getAttribute('data-index') || '0', 10), true);
        });
      });
      // Swiping the image updates the active thumbnail + overlays (keeps the two in sync)
      if (slidesWrap) {
        var sScrollT;
        slidesWrap.addEventListener('scroll', function () {
          if (pio && !pioDismissed) pio.classList.add('is-hidden');
          if (certsEl) certsEl.classList.add('is-hidden');
          clearTimeout(sScrollT);
          sScrollT = setTimeout(function () {
            var i = Math.round(slidesWrap.scrollLeft / slidesWrap.clientWidth);
            curIndex = i; setActiveThumb(i); updateOverlays(i);
          }, 90);
        }, { passive: true });
      }

      // Tap-to-zoom lightbox
      var lb = root.querySelector('[data-pdp-lightbox]');
      var zoom = root.querySelector('[data-pdp-zoom]');
      if (lb && zoom) {
        var track = lb.querySelector('[data-pdp-lb-track]');
        var slides = lb.querySelectorAll('.bw-pdp__lb-slide');
        var dotsWrap = lb.querySelector('[data-pdp-lb-dots]');
        var dots = [];
        slides.forEach(function (s, i) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'bw-pdp__lb-dot';
          d.setAttribute('aria-label', 'Go to image ' + (i + 1));
          d.addEventListener('click', function () { goTo(i, true); });
          if (dotsWrap) { dotsWrap.appendChild(d); dots.push(d); }
        });
        function setActiveDot(i) { dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); }); }
        function goTo(i, smooth) {
          if (i < 0) i = 0; if (i > slides.length - 1) i = slides.length - 1;
          curIndex = i;
          if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
          setActiveDot(i);
        }
        function openLb() {
          lb.removeAttribute('hidden');
          document.documentElement.style.overflow = 'hidden';
          if (slides[curIndex]) track.scrollLeft = slides[curIndex].offsetLeft;
          setActiveDot(curIndex);
        }
        function closeLb() {
          lb.setAttribute('hidden', '');
          document.documentElement.style.overflow = '';
        }
        zoom.addEventListener('click', openLb);
        zoom.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(); } });
        var closeBtn = lb.querySelector('[data-pdp-lb-close]');
        if (closeBtn) closeBtn.addEventListener('click', closeLb);
        var prevBtn = lb.querySelector('[data-pdp-lb-prev]');
        var nextBtn = lb.querySelector('[data-pdp-lb-next]');
        if (prevBtn) prevBtn.addEventListener('click', function () { goTo(curIndex - 1, true); });
        if (nextBtn) nextBtn.addEventListener('click', function () { goTo(curIndex + 1, true); });
        lb.addEventListener('click', function (e) { if (e.target.closest('button')) return; if (e.target.tagName === 'IMG') return; closeLb(); });
        var st;
        track.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(function () {
            var i = Math.round(track.scrollLeft / track.clientWidth);
            if (i !== curIndex) { curIndex = i; setActiveDot(i); }
          }, 90);
        });
        document.addEventListener('keydown', function (e) {
          if (lb.hasAttribute('hidden')) return;
          if (e.key === 'Escape') closeLb();
          else if (e.key === 'ArrowLeft') goTo(curIndex - 1, true);
          else if (e.key === 'ArrowRight') goTo(curIndex + 1, true);
        });
      }

      var idInput = root.querySelector('[data-pdp-id]');
      var planInput = root.querySelector('[data-pdp-plan]');
      var cta = root.querySelector('[data-pdp-cta]');
      var v90 = root.getAttribute('data-v90'), v30 = root.getAttribute('data-v30');
      var plan90 = root.getAttribute('data-plan90'), plan30 = root.getAttribute('data-plan30');
      var save90 = root.getAttribute('data-save90'), save30 = root.getAttribute('data-save30');
      var prefix = root.getAttribute('data-cta-prefix') || 'Subscribe & Save';

      // Value-spread slot swaps its jar count with the tier (3-jar for 90-day, 1-jar for 30-day).
      var valueIdx = parseInt(root.getAttribute('data-value-index'), 10);
      var valueAlt = root.getAttribute('data-value-alt') || '';
      var valueThumb = (valueIdx >= 0) ? root.querySelector('.bw-pdp__thumb[data-index="' + valueIdx + '"]') : null;
      var valueThumbOrig = valueThumb ? valueThumb.getAttribute('data-pdp-thumb') : '';
      var lbSlides = root.querySelectorAll('.bw-pdp__lb-slide img');
      var valueSlideOrig = lbSlides[valueIdx] ? lbSlides[valueIdx].getAttribute('src') : '';

      function setValueTier(tier) {
        if (!valueThumb || !valueAlt) return;
        var url = (tier === '30') ? valueAlt : valueThumbOrig;
        valueThumb.setAttribute('data-pdp-thumb', url);
        var timg = valueThumb.querySelector('img'); if (timg) timg.src = url;
        if (lbSlides[valueIdx]) lbSlides[valueIdx].src = (tier === '30') ? valueAlt : valueSlideOrig;
        if (stageImgs[valueIdx]) stageImgs[valueIdx].src = url;
      }

      root.querySelectorAll('[data-pdp-opt]').forEach(function (opt) {
        opt.querySelector('.bw-pdp__opt-head').addEventListener('click', function () {
          root.querySelectorAll('[data-pdp-opt]').forEach(function (o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          opt.querySelector('input[type=radio]').checked = true;
          var tier = opt.getAttribute('data-tier');
          idInput.value = tier === '30' ? v30 : v90;
          var pid = tier === '30' ? plan30 : plan90;
          if (pid) { planInput.value = pid; planInput.disabled = false; }
          else { planInput.value = ''; planInput.disabled = true; }
          if (cta) { var cl = cta.querySelector('[data-cta-l]'), cs = cta.querySelector('[data-cta-s]'); if (cl && cs) { cl.textContent = cta.getAttribute(tier === '30' ? 'data-cta-30' : 'data-cta-90'); cs.textContent = cta.getAttribute(tier === '30' ? 'data-cta-30s' : 'data-cta-90s'); } else { cta.textContent = cta.getAttribute(tier === '30' ? 'data-cta-30' : 'data-cta-90'); } }
          setValueTier(tier);
        });
      });

      root.querySelectorAll('.bw-pdp__acc-q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        });
      });

      // Sticky add-to-cart bar
      var sticky = root.querySelector('[data-pdp-sticky]');
      if (sticky) {
        // Show/hide on scroll past the main CTA — set up FIRST so it always runs,
        // even on the one-time/bundle PDP where the plan selector below is absent.
        var anchor = root.querySelector('.bw-pdp__cta');
        if (anchor && 'IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              // 2026-10-10: on mobile the buy box sits 2+ screens down, so the bar shows whenever the CTA is off-screen (above or below); desktop keeps 'after passing it'.
              var mobileSticky = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
              if (!en.isIntersecting && (mobileSticky || en.boundingClientRect.top < 0)) sticky.classList.add('is-visible');
              else sticky.classList.remove('is-visible');
            });
          }, { threshold: 0 }).observe(anchor);
        }

        // Plan selector (subscription PDPs only; not present on one-time/bundle).
        var sToggle = sticky.querySelector('[data-sticky-toggle]');
        var sMenu = sticky.querySelector('[data-sticky-menu]');
        if (sToggle && sMenu) {
          var sLabel = sticky.querySelector('[data-sticky-label]');
          var sSub = sticky.querySelector('[data-sticky-sub]');
          var sId = sticky.querySelector('[data-sticky-id]');
          var sPlan = sticky.querySelector('[data-sticky-splan]');
          var sCta = sticky.querySelector('[data-sticky-cta]');
          sToggle.addEventListener('click', function () {
            if (sMenu.hasAttribute('hidden')) { sMenu.removeAttribute('hidden'); sToggle.setAttribute('aria-expanded', 'true'); }
            else { sMenu.setAttribute('hidden', ''); sToggle.setAttribute('aria-expanded', 'false'); }
          });
          sticky.querySelectorAll('[data-sticky-opt]').forEach(function (opt) {
            opt.addEventListener('click', function () {
              if (sLabel) sLabel.textContent = opt.getAttribute('data-label');
              if (sSub) sSub.textContent = opt.getAttribute('data-sub');
              if (sId) sId.value = opt.getAttribute('data-variant');
              var pid = opt.getAttribute('data-plan');
              if (sPlan) { if (pid) { sPlan.value = pid; sPlan.disabled = false; } else { sPlan.value = ''; sPlan.disabled = true; } }
              if (sCta) sCta.textContent = opt.getAttribute('data-cta');
              sMenu.setAttribute('hidden', ''); sToggle.setAttribute('aria-expanded', 'false');
            });
          });
          document.addEventListener('click', function (e) { if (!sticky.contains(e.target)) sMenu.setAttribute('hidden', ''); });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-promobar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-bw-promobar]');
    if (!bar) return;
    var trig = parseInt(bar.getAttribute('data-trigger'), 10) || 700;
    function onScroll() {
      if (window.scrollY > trig) { bar.classList.add('is-visible'); document.body.classList.add('bw-promo-on'); }
      else { bar.classList.remove('is-visible'); document.body.classList.remove('bw-promo-on'); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-quality"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-q-acc]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('.bw-q__acc-q');
        if (!btn) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        list.querySelectorAll('.bw-q__acc-q[aria-expanded="true"]').forEach(function (b) { if (b !== btn) b.setAttribute('aria-expanded', 'false'); });
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-quiz-campaign"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-bw-quiz]');
    if (!root) return;
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-quiz-config]').textContent); } catch (e) { cfg = { products: {}, headlines: {} }; }
    var bar = root.querySelector('[data-quiz-bar]');
    var ORDER = ['q1', 'q2', 'q3', 'results']; // kampanj: inget e-poststeg, kunden kommer från mejlet
    var state = { q1: null, q2: null, q3: null };
    var kKey = root.getAttribute('data-klaviyo-key');
    var kList = root.getAttribute('data-klaviyo-list');

    function stepEl(id) { return root.querySelector('[data-quiz-step="' + id + '"]'); }
    function show(id) {
      if (id === 'results') renderResults(); // e-poststeget är borta: rita kortet när resultatsteget öppnas
      ORDER.forEach(function (s) { var el = stepEl(s); if (el) el.hidden = (s !== id); });
      var i = ORDER.indexOf(id);
      if (bar) bar.style.width = Math.round((i + 1) / ORDER.length * 100) + '%';
      var h = root.querySelector('[data-quiz-step="' + id + '"] .bw-quiz__q');
      if (h && h.focus) { try { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: false }); } catch (e) {} }
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function next(id) { var i = ORDER.indexOf(id); return ORDER[Math.min(i + 1, ORDER.length - 1)]; }
    function prev(id) { var i = ORDER.indexOf(id); return ORDER[Math.max(i - 1, 0)]; }

    // option selection -> advance
    root.querySelectorAll('[data-quiz-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.getAttribute('data-quiz-select');
        state[q] = btn.getAttribute('data-value');
        var sib = btn.parentNode.querySelectorAll('.bw-quiz__opt');
        sib.forEach(function (b) { b.classList.remove('is-sel'); });
        btn.classList.add('is-sel');
        setTimeout(function () { show(next(q)); }, 140);
      });
    });
    root.querySelectorAll('[data-quiz-back]').forEach(function (b) {
      b.addEventListener('click', function () {
        var cur = b.closest('[data-quiz-step]').getAttribute('data-quiz-step');
        show(prev(cur));
      });
    });

    function recommend() {
      if (state.q2 === 'capsules') return 'capsules';
      if (state.q2 === 'tincture') return 'tincture';
      return 'tincture'; // kampanj: 'either' → tinktur (EU-lagret har kapslar först om ~en vecka)
    }
    function renderResults() {
      var key = recommend();
      var p = (cfg.products || {})[key];
      var headline = (cfg.headlines || {})[state.q1] || (cfg.headlines || {}).overall || 'Your personalized ritual';
      var hEl = root.querySelector('[data-quiz-headline]'); if (hEl) hEl.textContent = headline;
      var card = root.querySelector('[data-quiz-card]');
      var ups = root.querySelector('[data-quiz-upsell]');
      if (!p) { if (card) card.innerHTML = '<p>' + (root.getAttribute('data-i18n-explore')||'Explore the whole range to find your fit.') + '</p>'; if (ups) ups.innerHTML = ''; return; }
      card.innerHTML =
        (p.img ? '<span class="bw-quiz__result-img"><img src="' + p.img + '" alt="" width="108" height="108"></span>' : '') +
        '<span class="bw-quiz__result-body">' +
          '<span class="bw-quiz__result-name">' + p.title + '</span>' +
          (p.why ? '<p class="bw-quiz__result-why">' + p.why + '</p>' : '') +
          '<span class="bw-quiz__result-price">' + (cfg.campaign.regular[key] ? '<s style="font-weight:400;opacity:.6">' + cfg.campaign.regular[key] + '</s> ' : '') + '<b>' + (cfg.campaign.first[key]||'') + ' today</b> ' + (cfg.campaign.firstLabel||'') + '<br><span style="font-weight:400;opacity:.75">Then ' + (cfg.campaign.then[key]||'') + ' ' + (cfg.campaign.thenLabel||'') + '</span></span><br>' +
          '<a class="bw-quiz__result-cta" href="' + (cfg.campaign.buy[key]||p.url) + '">' + (cfg.campaign.cta||'Claim 30% and go to checkout') + ' &rarr;</a>' +
        '</span>';
      var bundle = (cfg.products || {}).bundle;
      if (false && key !== 'bundle' && bundle) {
        ups.innerHTML = (root.getAttribute('data-i18n-prefer')||'Prefer to try both formats?') + ' <a href="' + bundle.url + '">' + (root.getAttribute('data-i18n-bundle')||'Get the Bundle — save 20%') + ' &rarr;</a>';
      } else { ups.innerHTML = ''; }
    }

    function toResults() { renderResults(); show('results'); }

    // email step
    var form = root.querySelector('[data-quiz-email]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = root.querySelector('[data-quiz-emailinput]').value.trim();
        var consent = root.querySelector('[data-quiz-consent]').checked;
        if (!email || email.indexOf('@') < 1) { root.querySelector('[data-quiz-emailinput]').focus(); return; }
        // Klaviyo capture only when configured AND consent given (approval-gated)
        if (kKey && kList && consent) {
          try {
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(kKey), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
              body: JSON.stringify({ data: { type: 'subscription', attributes: {
                custom_source: 'Website Quiz',
                profile: { data: { type: 'profile', attributes: { email: email, properties: {
                  quiz_goal: state.q1, quiz_format: state.q2, quiz_priority: state.q3, quiz_recommendation: recommend()
                } } } }
              }, relationships: { list: { data: { type: 'list', id: kList } } } } })
            }).catch(function () {});
            // fire a "Completed Quiz" event so the recommended-plan flow can trigger (and for quiz stats)
            fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(kKey), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
              body: JSON.stringify({ data: { type: 'event', attributes: {
                metric: { data: { type: 'metric', attributes: { name: 'Completed Quiz' } } },
                properties: { quiz_goal: state.q1, quiz_format: state.q2, quiz_priority: state.q3, quiz_recommendation: recommend() },
                profile: { data: { type: 'profile', attributes: { email: email } } }
              } } })
            }).catch(function () {});
          } catch (e) {}
        }
        toResults();
      });
      root.querySelector('[data-quiz-skip]').addEventListener('click', toResults);
    }
    root.querySelector('[data-quiz-restart]').addEventListener('click', function () {
      state = { q1: null, q2: null, q3: null };
      root.querySelectorAll('.bw-quiz__opt.is-sel').forEach(function (b) { b.classList.remove('is-sel'); });
      var em = root.querySelector('[data-quiz-emailinput]'); if (em) em.value = '';
      show('q1');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-bw-quiz]');
    if (!root) return;
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-quiz-config]').textContent); } catch (e) { cfg = { products: {}, headlines: {} }; }
    var bar = root.querySelector('[data-quiz-bar]');
    var ORDER = ['q1', 'q2', 'q3', 'results']; // e-poststeget borttaget (Jonas 2026-10-01: 'adderar bara friktion')
    var state = { q1: null, q2: null, q3: null };
    var kKey = root.getAttribute('data-klaviyo-key');
    var kList = root.getAttribute('data-klaviyo-list');

    function stepEl(id) { return root.querySelector('[data-quiz-step="' + id + '"]'); }
    function show(id) {
      if (id === 'results') renderResults(); // e-poststeget är borta: rita kortet när resultatsteget öppnas
      ORDER.forEach(function (s) { var el = stepEl(s); if (el) el.hidden = (s !== id); });
      var i = ORDER.indexOf(id);
      if (bar) bar.style.width = Math.round((i + 1) / ORDER.length * 100) + '%';
      var h = root.querySelector('[data-quiz-step="' + id + '"] .bw-quiz__q');
      if (h && h.focus) { try { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: false }); } catch (e) {} }
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function next(id) { var i = ORDER.indexOf(id); return ORDER[Math.min(i + 1, ORDER.length - 1)]; }
    function prev(id) { var i = ORDER.indexOf(id); return ORDER[Math.max(i - 1, 0)]; }

    // option selection -> advance
    root.querySelectorAll('[data-quiz-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.getAttribute('data-quiz-select');
        state[q] = btn.getAttribute('data-value');
        var sib = btn.parentNode.querySelectorAll('.bw-quiz__opt');
        sib.forEach(function (b) { b.classList.remove('is-sel'); });
        btn.classList.add('is-sel');
        setTimeout(function () { show(next(q)); }, 140);
      });
    });
    root.querySelectorAll('[data-quiz-back]').forEach(function (b) {
      b.addEventListener('click', function () {
        var cur = b.closest('[data-quiz-step]').getAttribute('data-quiz-step');
        show(prev(cur));
      });
    });

    function recommend() {
      if (state.q2 === 'capsules') return 'capsules';
      if (state.q2 === 'tincture') return 'tincture';
      return 'bundle';
    }
    function renderResults() {
      var key = recommend();
      var p = (cfg.products || {})[key];
      var headline = (cfg.headlines || {})[state.q1] || (cfg.headlines || {}).overall || 'Your personalized ritual';
      var hEl = root.querySelector('[data-quiz-headline]'); if (hEl) hEl.textContent = headline;
      var card = root.querySelector('[data-quiz-card]');
      var ups = root.querySelector('[data-quiz-upsell]');
      if (!p) { if (card) card.innerHTML = '<p>' + (root.getAttribute('data-i18n-explore')||'Explore the whole range to find your fit.') + '</p>'; if (ups) ups.innerHTML = ''; return; }
      card.innerHTML =
        (p.img ? '<span class="bw-quiz__result-img"><img src="' + p.img + '" alt="" width="108" height="108"></span>' : '') +
        '<span class="bw-quiz__result-body">' +
          '<span class="bw-quiz__result-name">' + p.title + '</span>' +
          (p.why ? '<p class="bw-quiz__result-why">' + p.why + '</p>' : '') +
          (p.price ? '<span class="bw-quiz__result-price">' + (root.getAttribute('data-i18n-from')||'From') + ' ' + p.price + '</span><br>' : '') +
          '<a class="bw-quiz__result-cta" href="' + p.url + '">' + (root.getAttribute('data-i18n-shop-this')||'Shop this') + ' &rarr;</a>' +
        '</span>';
      var bundle = (cfg.products || {}).bundle;
      if (key !== 'bundle' && bundle) {
        ups.innerHTML = (root.getAttribute('data-i18n-prefer')||'Prefer to try both formats?') + ' <a href="' + bundle.url + '">' + (root.getAttribute('data-i18n-bundle')||'Get the Bundle — save 20%') + ' &rarr;</a>';
      } else { ups.innerHTML = ''; }
    }

    function toResults() { renderResults(); show('results'); }

    // email step
    var form = root.querySelector('[data-quiz-email]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = root.querySelector('[data-quiz-emailinput]').value.trim();
        var consent = root.querySelector('[data-quiz-consent]').checked;
        if (!email || email.indexOf('@') < 1) { root.querySelector('[data-quiz-emailinput]').focus(); return; }
        // Klaviyo capture only when configured AND consent given (approval-gated)
        if (kKey && kList && consent) {
          try {
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(kKey), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
              body: JSON.stringify({ data: { type: 'subscription', attributes: {
                custom_source: 'Website Quiz',
                profile: { data: { type: 'profile', attributes: { email: email, properties: {
                  quiz_goal: state.q1, quiz_format: state.q2, quiz_priority: state.q3, quiz_recommendation: recommend()
                } } } }
              }, relationships: { list: { data: { type: 'list', id: kList } } } } })
            }).catch(function () {});
            // fire a "Completed Quiz" event so the recommended-plan flow can trigger (and for quiz stats)
            fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(kKey), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
              body: JSON.stringify({ data: { type: 'event', attributes: {
                metric: { data: { type: 'metric', attributes: { name: 'Completed Quiz' } } },
                properties: { quiz_goal: state.q1, quiz_format: state.q2, quiz_priority: state.q3, quiz_recommendation: recommend() },
                profile: { data: { type: 'profile', attributes: { email: email } } }
              } } })
            }).catch(function () {});
          } catch (e) {}
        }
        toResults();
      });
      root.querySelector('[data-quiz-skip]').addEventListener('click', toResults);
    }
    root.querySelector('[data-quiz-restart]').addEventListener('click', function () {
      state = { q1: null, q2: null, q3: null };
      root.querySelectorAll('.bw-quiz__opt.is-sel').forEach(function (b) { b.classList.remove('is-sel'); });
      var em = root.querySelector('[data-quiz-emailinput]'); if (em) em.value = '';
      show('q1');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-review-topics"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-rt]');
    if (!root) return;
    var repliedLabel = root.getAttribute('data-i18n-replied') || '✓ Company replied';
    var modal = root.querySelector('[data-rt-modal]');
    var LOGO = { tru: root.getAttribute('data-logo-tru'), rev: root.getAttribute('data-logo-rev'), ets: root.getAttribute('data-logo-ets') };
    var SRC = { tru: 'Trustpilot', rev: 'Reviews.io', ets: 'Etsy' };
    function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function stars(n) { n = Math.round(n) || 0; return '★★★★★☆☆☆☆☆'.slice(5 - n, 10 - n); }
    function reviewCard(r) {
      var mark = LOGO[r.s] ? '<img class="bw-rt__rev-logo" src="' + LOGO[r.s] + '" alt="' + esc(SRC[r.s] || r.s) + '">' : '<span class="bw-rt__rev-badge">' + esc(SRC[r.s] || r.s) + '</span>';
      var replied = r.rep ? '<div class="bw-rt__rev-replied">' + repliedLabel + '</div>' : '';
      return '<article class="bw-rt__rev"><div class="bw-rt__rev-top"><span class="bw-rt__rev-stars">' + stars(r.r) + '</span>' + mark + '</div>'
        + (r.b ? '<p class="bw-rt__rev-body">' + esc(r.b) + '</p>' : '')
        + '<div class="bw-rt__rev-meta">' + esc(r.n) + '' + '</div>' + replied + '</article>';
    }
    function findReviews(namesStr) {
      var names = (namesStr || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      var data = window.BW_REVIEWS || [];
      var out = [];
      names.forEach(function (nm) {
        for (var i = 0; i < data.length; i++) { if (data[i].n === nm) { out.push(data[i]); break; } }
      });
      return out.slice(0, 10);
    }
    function open(title, body, names) {
      root.querySelector('[data-rt-mtitle]').textContent = title;
      root.querySelector('[data-rt-mbody]').textContent = body;
      var revs = findReviews(names);
      root.querySelector('[data-rt-mreviews]').innerHTML = revs.length ? revs.map(reviewCard).join('') : '';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      root.querySelector('.bw-rt__modal-scroll').scrollTop = 0;
    }
    function close() { modal.hidden = true; document.body.style.overflow = ''; }
    root.querySelectorAll('[data-rt-more]').forEach(function (b) {
      b.addEventListener('click', function () { open(b.getAttribute('data-title'), b.getAttribute('data-body'), b.getAttribute('data-names')); });
    });
    root.querySelectorAll('[data-rt-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-reviews-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.bw-rw');
    if (!root) return;
    var DATA = [];
    var wall = root.querySelector('[data-rw-wall]');
    var moreBtn = root.querySelector('[data-rw-more]');
    var SRC = { tru: 'Trustpilot', rev: 'Reviews.io', ets: 'Etsy' };
    var LOGO = { tru: root.getAttribute('data-logo-tru'), rev: root.getAttribute('data-logo-rev'), ets: root.getAttribute('data-logo-ets') };
    var current = 'p', shown = 0, STEP = 15;

    function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function stars(n) { n = Math.round(n) || 0; return '★★★★★☆☆☆☆☆'.slice(5 - n, 10 - n); }

    function card(r) {
      var badge = LOGO[r.s] ? '<img class="bw-rw__logo bw-rw__logo--' + r.s + '" src="' + LOGO[r.s] + '" alt="' + esc(SRC[r.s] || r.s) + '" loading="lazy">' : '<span class="bw-rw__badge bw-rw__badge--' + r.s + '">' + esc(SRC[r.s] || r.s) + '</span>';
      var trans = r.be ? '<p class="bw-rw__trans"><span>' + (root.getAttribute('data-i18n-translated')||'Translated') + '</span>' + esc(r.be) + '</p>' : '';
      var reply = r.rep ? '<div class="bw-rw__reply"><strong>Blushwood Health</strong><p>' + esc(r.rep) + '</p></div>' : '';
      var prod = r.p ? '<span class="bw-rw__prod">' + esc(r.p) + '</span>' : '';
      var edited = r.ed ? '<p class="bw-rw__edited">' + esc(r.ed) + '</p>' : '';
      return '<article class="bw-rw__card">'
        + '<div class="bw-rw__card-top"><span class="bw-rw__stars" aria-label="' + r.r + ' out of 5">' + stars(r.r) + '</span>' + badge + '</div>'
        + (r.t ? '<h4>' + esc(r.t) + '</h4>' : '')
        + (r.b ? '<p class="bw-rw__body">' + esc(r.b) + '</p>' : '')
        + trans
        + edited
        + '<div class="bw-rw__meta">' + esc(r.n) + '' + prod + '</div>'
        + reply
        + '</article>';
    }

    function list() { return DATA.filter(function (r) { return r.ty === current; }); }
    function render() {
      var l = list();
      wall.innerHTML = l.slice(0, shown).map(card).join('');
      moreBtn.hidden = shown >= l.length;
    }
    function setTab(t) {
      current = t; shown = STEP;
      root.querySelectorAll('[data-rw-tab]').forEach(function (b) {
        var on = b.getAttribute('data-rw-tab') === t;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      render();
    }

    root.querySelectorAll('[data-rw-tab]').forEach(function (b) { b.addEventListener('click', function () { setTab(b.getAttribute('data-rw-tab')); }); });
    moreBtn.addEventListener('click', function () { shown += STEP; render(); });

    function init() {
      setTab('c');
    }
    var tries = 0;
    function boot() {
      if (window.BW_REVIEWS && Array.isArray(window.BW_REVIEWS)) { DATA = window.BW_REVIEWS; init(); }
      else if (tries++ < 60) { setTimeout(boot, 50); }
      else { wall.innerHTML = '<p style="text-align:center;color:#7a8b84">' + (root.getAttribute('data-i18n-loading')||'Reviews are loading — please refresh.') + '</p>'; }
    }
    boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORE = 'blushwood.health';
    var SKUS = ['BH-001', 'BH-003', 'BH-006'];
    // Exclude cancer / tumour cluster + hardest medical claims
    var BANNED = /(cancer|tumou?r|melanoma|carcinoma|oncolog|metasta|malignan|\bchemo|\bbiops|bleeding disorder|\bseizure|no longer taking|off my meds|stopped taking)/i;  // Jonas 2026-11-04: skin self-reports (moles, warts, skin tags, lumps, lesions, cysts, spider veins, sun damage) ARE featured; only cancer-cluster + medication-stopping stay out

    function catOf(t) {
      t = t.toLowerCase();
      if (/skin|complexion|smooth|face|hydrat|nourish|glow/.test(t)) return 'Skin';
      if (/energy|energet|vital|stamina|positiv|stronger/.test(t)) return 'Energy';
      if (/feel better|feeling better|difference|healthy|wellbeing|well-being|inflamm|better than|recovery|so much better/.test(t)) return 'Wellbeing';
      if (/month|week|time|consist|longer|slowly|gradual|6 month|reorder|subscrib/.test(t)) return 'Over time';
      return 'Quality & Trust';
    }
    function tagsOf(t) {
      t = t.toLowerCase(); var out = [];
      if (/energy|energet/.test(t)) out.push('Energy');
      if (/skin|face|hydrat/.test(t)) out.push('Skin');
      if (/delivery|arriv|quick|fast|shipp/.test(t)) out.push('Fast delivery');
      if (/service|support|staff|team|profession|respon/.test(t)) out.push('Great service');
      if (/quality|high[- ]quality/.test(t)) out.push('Quality');
      if (/recommend/.test(t)) out.push('Recommended');
      if (/again|reorder|repurchas|subscrib/.test(t)) out.push('Repeat customer');
      return out.slice(0, 2);
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    function buildCard(r) {
      var text = (r.text || '').replace(/\s+/g, ' ').trim();
      var name = (r.name || 'Verified customer').trim();
      var cat = catOf(text + ' ' + (r.title || ''));
      var tags = tagsOf(text + ' ' + (r.title || ''));
      var el = document.createElement('article');
      el.className = 'bw-rv-card';
      el.setAttribute('data-cat', cat);
      el.setAttribute('data-dyn', '1');
      el.innerHTML =
        '<header class="bw-rv-card__head">' +
          '<span class="bw-rv-card__avatar">' + esc(name.charAt(0).toUpperCase()) + '</span>' +
          '<div class="bw-rv-card__who"><span class="bw-rv-card__name">' + esc(name) + '</span>' +
          (r.loc ? '<span class="bw-rv-card__loc">' + esc(r.loc) + '</span>' : '') + '</div>' +
          '<span class="bw-rv-card__badge">' + cat + '</span>' +
        '</header>' +
        (r.title ? '<h3 class="bw-rv-card__title">' + esc(r.title) + '</h3>' : '') +
        '<blockquote class="bw-rv-card__quote">“' + esc(text) + '”</blockquote>' +
        (tags.length ? '<div class="bw-rv-card__tags">' + tags.map(function (x) { return '<span>' + esc(x) + '</span>'; }).join('') + '</div>' : '') +
        '<footer class="bw-rv-card__foot"><span class="bw-rv-card__verified">' +
          '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 10.5l3.5 3.5L16 6" stroke="var(--color-mint)" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          ' Verified buyer <span class="bw-rv-card__src">· Reviews.io</span></span>' +
          '<span class="bw-rv-card__stars">★★★★★</span></footer>';
      return el;
    }

    document.querySelectorAll('[data-rv-track]').forEach(function (track) {
      var section = track.closest('section');
      var filters = section.querySelector('[data-rv-filters]');
      var countEl = section.querySelector('[data-rv-count]');
      var moreBtn = section.querySelector('[data-rv-more]');
      var moreWrap = section.querySelector('[data-rv-morewrap]');
      function getCards() { return Array.prototype.slice.call(track.querySelectorAll('.bw-rv-card')); }
      function activeCat() { var a = section.querySelector('.bw-rv__chip.is-active'); return a ? a.getAttribute('data-cat') : 'all'; }

      function applyFilter(cat) {
        var shown = 0;
        getCards().forEach(function (card) {
          var m = cat === 'all' || card.getAttribute('data-cat') === cat;
          card.classList.toggle('is-hidden', !m);
          if (m) shown++;
        });
        if (countEl) countEl.textContent = shown + (shown === 1 ? ' review' : ' reviews');
      }
      function recount() {
        var cards = getCards();
        section.querySelectorAll('.bw-rv__chip').forEach(function (chip) {
          var cat = chip.getAttribute('data-cat');
          var n = cat === 'all' ? cards.length : cards.filter(function (c) { return c.getAttribute('data-cat') === cat; }).length;
          var em = chip.querySelector('em'); if (em) em.textContent = n;
        });
        applyFilter(activeCat());
      }

      if (filters) {
        filters.addEventListener('click', function (e) {
          var chip = e.target.closest('.bw-rv__chip');
          if (!chip) return;
          filters.querySelectorAll('.bw-rv__chip').forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          applyFilter(chip.getAttribute('data-cat'));
          track.scrollTo({ left: 0, behavior: 'smooth' });
        });
      }
      function step() { var c = track.querySelector('.bw-rv-card:not(.is-hidden)'); return c ? c.getBoundingClientRect().width + 18 : 340; }
      var prev = section.querySelector('[data-rv-prev]');
      var next = section.querySelector('[data-rv-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      // Live loader
      var pool = [], loaded = false, revealed = 0, seen = {};
      getCards().forEach(function (c) {
        var q = c.querySelector('.bw-rv-card__quote'); if (q) seen[q.textContent.replace(/[^a-z0-9]/gi, '').slice(0, 40).toLowerCase()] = 1;
      });
      function key(t) { return (t || '').replace(/[^a-z0-9]/gi, '').slice(0, 40).toLowerCase(); }
      function decode(s) { var d = document.createElement('textarea'); d.innerHTML = s || ''; return d.value; }

      function fetchAll() {
        var reqs = [];
        SKUS.forEach(function (sku) {
          reqs.push(fetch('https://api.reviews.io/product/reviews?store=' + STORE + '&sku=' + sku + '&per_page=100').then(function (r) { return r.json(); }).then(function (d) {
            return (d.reviews || []).map(function (r) {
              var rv = r.reviewer || {};
              return { rating: r.rating, title: decode(r.name), text: decode(r.review), name: (rv.first_name || '') + (rv.last_name ? ' ' + rv.last_name.charAt(0) + '.' : ''), loc: (rv.address || '').trim() };
            });
          }).catch(function () { return []; }));
        });
        for (var p = 0; p < 8; p++) {
          reqs.push(fetch('https://api.reviews.io/merchant/reviews?store=' + STORE + '&per_page=20&page=' + p).then(function (r) { return r.json(); }).then(function (d) {
            return (d.reviews || []).map(function (r) {
              var rv = r.reviewer || {};
              return { rating: r.rating, title: decode(r.title), text: decode(r.comments), name: (rv.first_name || 'Verified customer') + (rv.last_name ? ' ' + rv.last_name.charAt(0) + '.' : ''), loc: (rv.address || '').trim() };
            });
          }).catch(function () { return []; }));
        }
        return Promise.all(reqs).then(function (chunks) {
          var all = [];
          chunks.forEach(function (c) { all = all.concat(c); });
          all.forEach(function (r) {
            var t = (r.text || '').trim();
            if (!r.rating || r.rating < 4) return;
            if (t.length < 40) return;
            if (BANNED.test(t + ' ' + (r.title || ''))) return;
            var k = key(t);
            if (seen[k]) return;
            seen[k] = 1;
            pool.push(r);
          });
          loaded = true;
        });
      }

      function reveal(n) {
        var frag = document.createDocumentFragment();
        var end = Math.min(revealed + n, pool.length);
        for (var i = revealed; i < end; i++) frag.appendChild(buildCard(pool[i]));
        track.appendChild(frag);
        revealed = end;
        recount();
        if (revealed >= pool.length && moreWrap) moreWrap.style.display = 'none';
      }

      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          moreBtn.disabled = true; moreBtn.textContent = 'Loading…';
          var go = loaded ? Promise.resolve() : fetchAll();
          go.then(function () {
            moreBtn.disabled = false; moreBtn.textContent = moreBtn.getAttribute('data-label') || 'Load more reviews';
            if (!pool.length) { if (moreWrap) moreWrap.style.display = 'none'; return; }
            reveal(16);
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sci-acc]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('.bw-sci__acc-q');
        if (!btn) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        list.querySelectorAll('.bw-sci__acc-q[aria-expanded="true"]').forEach(function (b) { if (b !== btn) b.setAttribute('aria-expanded', 'false'); });
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-track"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bw-trk__card').forEach(function (card) {
      var endpoint = card.getAttribute('data-track-endpoint');
      var T = {}; try { T = JSON.parse(card.querySelector('[data-trk-i18n]').textContent); } catch (e) {}
      var trackerBase = card.getAttribute('data-tracker-base') || 'https://t.17track.net/en#nums=';
      var result = card.querySelector('[data-track-result]');

      // tabs
      card.querySelectorAll('.bw-trk__tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          card.querySelectorAll('.bw-trk__tab').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          var key = tab.getAttribute('data-tab');
          card.querySelectorAll('.bw-trk__panel').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === key); });
          result.hidden = true;
        });
      });

      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function show(html) { result.innerHTML = html; result.hidden = false; }
      function pretty(s) { return String(s || '').toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, function (m) { return m.toUpperCase(); }); }

      // tracking number tab -> universal tracker
      card.querySelector('[data-track="tracking"]').addEventListener('click', function () {
        var num = (card.querySelector('#trk-num').value || '').trim();
        if (!num) { show('<span class="bw-trk__rerr">' + (T.enter_tracking || 'Please enter your tracking number.') + '</span>'); return; }
        window.open(trackerBase + encodeURIComponent(num), '_blank', 'noopener');
      });

      // order number + email tab -> worker lookup
      var orderBtn = card.querySelector('[data-track="order"]');
      orderBtn.addEventListener('click', function () {
        var order = (card.querySelector('#trk-order').value || '').trim();
        var email = (card.querySelector('#trk-email').value || '').trim();
        if (!order || !email) { show('<span class="bw-trk__rerr">' + (T.enter_both || 'Please enter both your order number and email.') + '</span>'); return; }
        if (!endpoint) { show('<span class="bw-trk__rerr">' + (T.lookup_unavailable || 'Order lookup is unavailable right now — please contact us.') + '</span>'); return; }
        orderBtn.disabled = true; var label = orderBtn.textContent; orderBtn.textContent = (T.checking || 'Checking…');
        var u = endpoint + (endpoint.indexOf('?') >= 0 ? '&' : '?') + 'order=' + encodeURIComponent(order) + '&email=' + encodeURIComponent(email);
        fetch(u).then(function (r) { return r.json(); }).then(function (d) {
          if (!d || d.error) { show('<span class="bw-trk__rerr">' + esc(d && d.error ? d.error : (T.generic_error || 'Something went wrong. Please try again.')) + '</span>'); return; }
          if (!d.found) {
            show('<span class="bw-trk__rmsg">' + (T.not_found || 'We couldn’t find an order matching that number and email. Double-check both — the email must be the one used at checkout — or <a href="/pages/contact">contact us</a>.') + '</span>');
            return;
          }
          var html = '<span class="bw-trk__rname">' + (T.order_word || 'Order') + ' ' + esc(d.name) + '</span>';
          html += '<span class="bw-trk__rstatus' + (d.fulfillmentStatus === 'FULFILLED' ? '' : ' is-muted') + '">' + esc(pretty(d.fulfillmentStatus) || (T.order_received || 'Order received')) + '</span>';
          var ful = d.fulfillments || [], hasTrack = false;
          ful.forEach(function (f) {
            (f.tracking || []).forEach(function (t) {
              hasTrack = true;
              var line = t.url ? '<a href="' + esc(t.url) + '" target="_blank" rel="noopener">' + (T.track_parcel || 'Track your parcel') + ' &rarr;</a>' : '<span>' + esc(t.company || (T.tracking_word || 'Tracking')) + '</span>';
              html += '<span class="bw-trk__rtrack">' + line + (t.company || t.number ? '<span class="bw-trk__rmeta">' + esc([t.company, t.number].filter(Boolean).join(' · ')) + '</span>' : '') + '</span>';
            });
            if (f.displayStatus) html += '<span class="bw-trk__rmeta">' + (T.latest || 'Latest:') + ' ' + esc(pretty(f.displayStatus)) + '</span>';
          });
          if (!hasTrack) html += '<span class="bw-trk__rtrack"><span class="bw-trk__rmeta">' + (T.no_tracking || 'No tracking is available yet — it will appear here once your order ships.') + '</span></span>';
          if (d.statusPageUrl) html += '<a class="bw-trk__rlink" href="' + esc(d.statusPageUrl) + '" target="_blank" rel="noopener">' + (T.view_full || 'View full order status') + ' &rarr;</a>';
          show(html);
        }).catch(function () {
          show('<span class="bw-trk__rerr">' + (T.unreachable || 'We couldn’t reach the tracking service. Please try again in a moment.') + '</span>');
        }).then(function () { orderBtn.disabled = false; orderBtn.textContent = label; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-trustpilot"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STARS5 = '<svg class="bw-tps-svg" viewBox="0 0 512 96" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect fill="#00B67A" x="0" y="0" width="96" height="96"/><rect fill="#00B67A" x="104" y="0" width="96" height="96"/><rect fill="#00B67A" x="208" y="0" width="96" height="96"/><rect fill="#00B67A" x="312" y="0" width="96" height="96"/><rect fill="#00B67A" x="416" y="0" width="96" height="96"/><path fill="#FFFFFF" d="M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 Z M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 Z M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 Z M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 Z M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 Z"/></svg>';
    var REPLY_ICON = '<svg class="bw-tp-card__reply-icon" viewBox="0 0 16 16" aria-hidden="true"><path d="M7 3L3 7l4 4M3 7h6a4 4 0 0 1 4 4v1" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function esc(s){ var d=document.createElement('div'); d.textContent=s==null?'':s; return d.innerHTML; }
    function ago(iso){ var d=new Date(iso); if(isNaN(d)) return ''; var s=(Date.now()-d.getTime())/1000, m=s/60, h=m/60, days=h/24; if(h<1)return Math.max(1,Math.round(m))+' minutes ago'; if(days<1){var hh=Math.round(h);return hh+(hh===1?' hour ago':' hours ago');} if(days<30){var dd=Math.round(days);return dd+(dd===1?' day ago':' days ago');} var mo=days/30.44; if(mo<12){var mm=Math.round(mo);return mm+(mm===1?' month ago':' months ago');} var y=Math.round(mo/12); return y+(y===1?' year ago':' years ago'); }

    var _tp = document.querySelector('.bw-tp');
    var I18N = {
      reply_from: (_tp && _tp.getAttribute('data-i18n-reply-from')) || 'Reply from [brand]',
      read_more: (_tp && _tp.getAttribute('data-i18n-read-more')) || 'Read more',
      read_less: (_tp && _tp.getAttribute('data-i18n-read-less')) || 'Read less',
      show_more: (_tp && _tp.getAttribute('data-i18n-show-more')) || 'Show more reviews'
    };
    function buildCard(x, brand){
      var el = document.createElement('article');
      el.className = 'bw-tp-card';
      var reply = x.r ? ('<div class="bw-tp-card__reply"><div class="bw-tp-card__reply-head">' + REPLY_ICON + '<span>' + I18N.reply_from.replace('[brand]', esc(brand)) + '</span>' + '' + '</div><div class="bw-tp-card__reply-text">' + esc(x.r) + '</div></div>') : '';
      var needsToggle = (x.b && x.b.length > 150) || !!x.r;
      el.innerHTML = STARS5 +
        '<div class="bw-tp-card__meta"><strong class="bw-tp-card__name">' + esc(x.n) + '</strong>' + '' + '</div>' +
        (x.t ? '<h3 class="bw-tp-card__title">' + esc(x.t) + '</h3>' : '') +
        '<div class="bw-tp-card__text">' + esc(x.b) + '</div>' +
        reply +
        (needsToggle ? '<button class="bw-tp-card__toggle" type="button" aria-expanded="false">' + I18N.read_more + '</button>' : '');
      return el;
    }

    document.querySelectorAll('.bw-tp').forEach(function (section) {
      var grid = section.querySelector('[data-tp-grid]');
      var dataEl = section.querySelector('#bw-tp-data');
      if (!grid || !dataEl) return;
      var brand = section.getAttribute('data-brand') || 'Blushwood Health';
      var data = [];
      try { data = JSON.parse(dataEl.textContent); } catch (e) {}
      var INITIAL = 8;
      var moreBtn = section.querySelector('[data-tp-more]');
      var moreWrap = section.querySelector('[data-tp-morewrap]');
      var wrap = section.querySelector('[data-tp-wrap]');
      var moreLabel = section.querySelector('[data-tp-more-label]');
      var expanded = false;

      function renderRange(a, b){
        var frag = document.createDocumentFragment();
        for (var i = a; i < b; i++) frag.appendChild(buildCard(data[i], brand));
        grid.appendChild(frag);
        grid.querySelectorAll('[data-date]').forEach(function (el) { if (!el.textContent) { var t = ago(el.getAttribute('data-date')); if (t) el.textContent = t; } });
      }
      renderRange(0, Math.min(INITIAL, data.length));
      if (data.length <= INITIAL) { if (moreWrap) moreWrap.style.display = 'none'; if (wrap) wrap.classList.remove('is-collapsed'); }

      if (moreBtn) moreBtn.addEventListener('click', function () {
        if (!expanded) {
          renderRange(INITIAL, data.length);
          if (wrap) wrap.classList.remove('is-collapsed');
          if (moreLabel) moreLabel.textContent = 'Show less';
          moreBtn.classList.add('is-open');
          expanded = true;
        } else {
          var cards = grid.querySelectorAll('.bw-tp-card');
          for (var i = cards.length - 1; i >= INITIAL; i--) cards[i].remove();
          if (wrap) wrap.classList.add('is-collapsed');
          if (moreLabel) moreLabel.textContent = I18N.show_more;
          moreBtn.classList.remove('is-open');
          expanded = false;
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      grid.addEventListener('click', function (e) {
        var btn = e.target.closest('.bw-tp-card__toggle');
        if (!btn) return;
        var card = btn.closest('.bw-tp-card');
        var open = card.classList.toggle('is-open');
        btn.textContent = open ? I18N.read_less : I18N.read_more;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-welcome-popup"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('bw-wpop');
  if (!root) return;
  var LS_KEY = 'bw_wpop_v2', DONE_KEY = 'bw_wpop_done', PAID_KEY = 'bw_paid';
  var days = parseInt(root.getAttribute('data-suppress-days') || '30', 10);
  var delay = parseInt(root.getAttribute('data-delay') || '12', 10);
  var company = root.getAttribute('data-company');
  var listId = root.getAttribute('data-list');
  var exitIntent = root.getAttribute('data-exit-intent') === '1';
  var paidMode = root.getAttribute('data-paid-mode') || 'exit';
  var desktopTimer = root.getAttribute('data-desktop-timer') === '1';
  var mobileMode = root.getAttribute('data-mobile-mode') || 'after_cta';
  var delayMobile = parseInt(root.getAttribute('data-delay-mobile') || '60', 10);
  var excl = (root.getAttribute('data-exclude') || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
  var force = /[?&]wpop=(test|1)/.test(location.search);
  var enabled = root.getAttribute('data-enabled') === '1';
  var desktop = !!(window.matchMedia && window.matchMedia('(pointer:fine)').matches);

  function ls(k){ try { return localStorage.getItem(k); } catch(e){ return null; } }
  function lsSet(k, v){ try { localStorage.setItem(k, v); } catch(e){} }
  function ss(k){ try { return sessionStorage.getItem(k); } catch(e){ return null; } }
  function ssSet(k, v){ try { sessionStorage.setItem(k, v); } catch(e){} }
  function track(name){ try { if (window.clarity) window.clarity('event', name); } catch(e){} }

  // Paid session: click ids or a paid utm_medium anywhere in this session.
  var q = location.search;
  var paidNow = /[?&](gclid|gbraid|wbraid|gad_source|fbclid|ttclid|msclkid)=/.test(q) || /[?&]utm_medium=(paid|cpc|ppc|paid_social|paidsocial)/i.test(q);
  if (paidNow) ssSet(PAID_KEY, '1');
  var paid = paidNow || ss(PAID_KEY) === '1';

  function suppressed(){ var raw = ls(LS_KEY); if (!raw) return false; var t = parseInt(raw, 10); return t && (Date.now() - t) < days * 864e5; }
  function suppress(){ lsSet(LS_KEY, String(Date.now())); }

  if (!force && !enabled) return;
  if (!force && ls(DONE_KEY)) return;
  if (!force && excl.some(function(p){ return p && location.pathname.indexOf(p) !== -1; })) return;
  if (!force && suppressed()) return;
  if (!force && paid && paidMode === 'off') return;

  var opened = false;
  function openPop(){
    if (opened) return; opened = true;
    root.hidden = false; root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    track('popup_shown');
  }
  function closePop(){
    root.hidden = true; root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (!force) suppress();
    track('popup_dismiss');
  }
  root.querySelectorAll('[data-wpop-close]').forEach(function(el){ el.addEventListener('click', closePop); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !root.hidden) closePop(); });

  // Primary: one-tap checkout with the 90-Day plan. Engaged = never show again on this browser.
  root.querySelectorAll('[data-wpop-trial]').forEach(function(a){
    a.addEventListener('click', function(){
      if (!force) { suppress(); lsSet(DONE_KEY, '1'); }
      track('popup_trial_click');
      var cc = (window.Shopify && Shopify.country) || '';
      if (cc && a.href.indexOf('country=') === -1) a.href += (a.href.indexOf('?') === -1 ? '?' : '&') + 'country=' + encodeURIComponent(cc);
    });
  });

  // Secondary: email -> Klaviyo subscribe + Popup Signup event -> reveal the one-time 10% auto-apply link.
  var form = root.querySelector('[data-wpop-form]');
  if (form) form.addEventListener('submit', function(e){
    e.preventDefault();
    var input = form.querySelector('input[name="email"]');
    var err = form.querySelector('[data-wpop-err]');
    var btn = form.querySelector('[data-wpop-submit]');
    var email = (input.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.hidden = false; input.focus(); return; }
    err.hidden = true; btn.disabled = true;
    var payload = { data: { type: 'subscription', attributes: {
      custom_source: 'Welcome Popup v3',
      profile: { data: { type: 'profile', attributes: { email: email, properties: { welcome_offer: 'onetime10', welcome_popup: 'v3' } } } }
    }, relationships: { list: { data: { type: 'list', id: listId } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(payload)
    }).then(function(res){
      btn.disabled = false;
      if (res.ok || res.status === 202) {
        fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: { type: 'event', attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Popup Signup' } } },
            properties: { source: 'Welcome Popup v3', welcome_offer: 'onetime10' },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          } } })
        }).catch(function(){});
        if (!force) { suppress(); lsSet(DONE_KEY, '1'); }
        track('popup_signup');
        form.hidden = true; var done = root.querySelector('[data-wpop-done]'); if (done) done.hidden = false;
      } else { err.textContent = 'Something went wrong, please try again.'; err.hidden = false; }
    }).catch(function(){ btn.disabled = false; err.textContent = 'Something went wrong, please try again.'; err.hidden = false; });
  });

  // Trigger v4. Paid sessions: exit-intent only (default), never, or same as organic.
  if (force) { openPop(); return; }
  var paidExitOnly = paid && paidMode === 'exit';
  if (desktop) {
    // Desktop: exit-intent; a timer only if explicitly enabled and the session is not paid-exit-only.
    if (exitIntent || paidExitOnly) document.addEventListener('mouseout', function(e){ if (!e.relatedTarget && e.clientY <= 0) openPop(); });
    if (desktopTimer && !paidExitOnly) setTimeout(openPop, Math.max(0, delay) * 1000);
  } else if (!paidExitOnly) {
    // Mobile: never on arrival. Open once the buy button has scrolled out above (the visitor has seen the offer and moved on),
    // or after delayMobile seconds on pages without a buy button (or when the observer is unsupported).
    var cta = document.querySelector('[data-pdp-cta], .bw-pdp__cta');
    if (mobileMode === 'after_cta' && cta && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting) seen = true;
          else if (seen && en.boundingClientRect.top < 0) openPop();
        });
      }, { threshold: 0 }).observe(cta);
      if (delayMobile > 0) setTimeout(openPop, delayMobile * 1000);
    } else if (mobileMode !== 'off') {
      setTimeout(openPop, Math.max(0, delayMobile > 0 ? delayMobile : delay) * 1000);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var header = document.querySelector('[data-bw-header]');
    if (!header) return;
    if (e.target.closest('[data-bw-burger]')) {
      var open = header.classList.toggle('bw-drawer-open');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      var b = header.querySelector('[data-bw-burger]');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (e.target.closest('[data-bw-close]')) {
      header.classList.remove('bw-drawer-open');
      document.documentElement.style.overflow = '';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var header = document.querySelector('[data-bw-header]');
      if (header) { header.classList.remove('bw-drawer-open'); document.documentElement.style.overflow = ''; }
    }
  });

  /* Smart sticky nav — PDPs only (they have the bottom add-to-cart bar; the promo bar doesn't stick here).
     Hide on scroll-down, reveal on scroll-up, always show near the top. Toggles a class on the sticky wrapper. */
  (function () {
    var header = document.querySelector('[data-bw-header]');
    if (!header) return;
    if (!document.querySelector('[data-pdp-sticky]')) return;
    var wrap = header.closest('.shopify-section');
    if (!wrap) return;
    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var THRESHOLD = 180, DELTA = 6, ticking = false;
    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (!header.classList.contains('bw-drawer-open')) {
        if (y <= THRESHOLD) wrap.classList.remove('bw-nav-hidden');
        else if (y > lastY + DELTA) wrap.classList.add('bw-nav-hidden');
        else if (y < lastY - DELTA) wrap.classList.remove('bw-nav-hidden');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
